
  (function () {
    var box = document.getElementById("grSearch");
    if (!box) return;
    var input = box.querySelector(".gr-search-input");
    var suggest = box.querySelector(".gr-search-suggest");
    var results = box.querySelector(".gr-search-results");
    var list = box.querySelector(".gr-search-products");
    var timer = null;

    window.grOpenSearch = function () {
      var hdr = document.querySelector(".mobile-header-wrapper");
      if (hdr) { document.documentElement.style.setProperty("--gr-search-top", hdr.getBoundingClientRect().bottom + "px"); }
      box.classList.add("is-open");
      box.setAttribute("aria-hidden", "false");
      setTimeout(function () { input.focus(); }, 60);
    };

    window.grCloseSearch = function () {
      box.classList.remove("is-open");
      box.setAttribute("aria-hidden", "true");
      input.blur();
    };

    document.addEventListener("keydown", function (e) { if (e.key === "Escape") window.grCloseSearch(); });

    // resultats en direct (recherche predictive Shopify)
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; suggest.hidden = false; return; }
      timer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            list.innerHTML = "";
            items.forEach(function (p) {
              var li = document.createElement("li");
              var a = document.createElement("a");
              a.href = p.url;
              if (p.image) { var img = document.createElement("img"); img.src = p.image; img.alt = ""; a.appendChild(img); }
              var t = document.createElement("span"); t.textContent = p.title; a.appendChild(t);
              li.appendChild(a); list.appendChild(li);
            });
            results.hidden = items.length === 0;
            suggest.hidden = items.length > 0;
          })
          .catch(function () {});
      }, 220);
    });
  })();
